var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"signup-page"}},[_c('Navigation',{attrs:{"frontEndUrl":_vm.frontEndUrl,"directUrl":_vm.directUrl,"partnerUrl":_vm.partnerUrl}}),_vm._t("default"),_c('Footer',{attrs:{"frontEndUrl":_vm.frontEndUrl}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }